<template>
  <div v-if="value?.length">
    <div
      v-for="(submission, index) in value"
      :key="index"
      class="my-6 max-w-40 break-normal whitespace-nowrap"
    >
      {{ getValue(submission) }}
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import { type PropType } from "vue";

import { SUBMISSION_TYPES } from "@/helpers/constants";

defineProps({
  value: {
    type: Array as PropType<number[]>,
  },
});

const getValue = (submission: number) =>
  SUBMISSION_TYPES[submission as keyof typeof SUBMISSION_TYPES];
</script>
